<mat-dialog-content class="axon-welcome-text-center" [@snFadeInDown]>
  <main class="axon-welcome-padding-small">
    <h3 class="header">Introducing Axon Fusus</h3>
    <p>Welcome to Axon's new real-time operations solution powered by Fusus. With Fusus you get:</p>
    <ul>
      <li>
        <strong>Live Streaming and Device Location</strong>: Instantly access video feeds and device
        locations from Axon devices
      </li>
      <li>
        <strong>Enhanced Search</strong>: Expand automatic license plate recognition (ALPR) searches
        across multiple assets
      </li>
      <li>
        <strong>Real-Time Collaboration</strong>: Enable seamless communication and information
        sharing among team members
      </li>
    </ul>
    <p>
      Keep a look out for more updates as we continue to grow and expand our offerings to help you
      make faster, more informed decisions in critical moments.
    </p>
  </main>

  <mat-dialog-actions>
    <button mat-button color="success" (click)="close()">Get Started</button>
  </mat-dialog-actions>
</mat-dialog-content>
